<template>
  <div class="modal-card" :style="{minHeight: 60 + 'vh', minWidth: 60 + 'vw'}">
    <header class="modal-card-head">
      <p class="modal-card-title">
        Email reminder history detail
      </p>
      <button
        type="button"
        class="delete"
        @click="$emit('on-close')"
      />
    </header>
    <section class="modal-card-body">
      <p class="mb-3">
        {{ distributor.id }} - {{ distributor.name }}
      </p>
      <b-loading v-model="isLoading" :is-full-page="false" />
      <b-table
        :data="histories"
        detailed
        :row-class="(row, index) => !!row.byPilot ? 'is-info' : ''"
        hoverable
        @details-open="onOpenDetails"
      >
        <b-table-column
          v-slot="props"
          field="sendAt"
          label="Sent on"
          sortable
        >
          <template>
            {{ props.row.sendAt ? $dayjs(props.row.sendAt).format('YYYY-MM-DD') : '' }}
          </template>
        </b-table-column>

        <b-table-column
          v-slot="props"
          field="sendTo"
          label="Sent to"
        >
          <template>
            {{ props.row.sendTo }}
          </template>
        </b-table-column>

        <b-table-column
          v-slot="props"
          label="Declaration"
        >
          <template>
            <span
              :class="
                [
                  'tag',
                  {'is-danger': !props.row.declarationId},
                  {'is-primary': props.row.declarationId}
                ]"
            >
              {{ props.row.declarationId ? 'Yes' : 'No' }}
            </span>
          </template>
        </b-table-column>

        <b-table-column
          v-slot="props"
          field="uploadDate"
          label="Declared On"
          sortable
        >
          <template>
            {{ props.row.uploadDate ? $dayjs(props.row.uploadDate).format('YYYY-MM-DD') : '' }}
          </template>
        </b-table-column>

        <b-table-column
          v-slot="props"
          field="sendType"
          label="Type"
        >
          <template>
            {{ props.row.sendType
              ? props.row.sendType
              : props.row.byPilot
                ? 'Operator'
                : 'N/A'
            }}
          </template>
        </b-table-column>

        <b-table-column
          v-slot="props"
          label="File"
        >
          <template v-if="props.row.declarationId && props.row.filePath">
            <b-button size="is-small" type="is-link" @click="downloadFile(props.row.declarationId)">
              Download
            </b-button>
          </template>

          <template v-if="props.row.declarationId && props.row.hasNothing">
            <span class="tag">Nothing declared</span>
          </template>
        </b-table-column>

        <b-table-column
          v-slot="props"
          label="By"
        >
          <template>
            {{ props.row.uploadedBy }}

            <b-button
              v-if="props.row.byPilot"
              class="delete-btn"
              type="is-danger"
              icon-right="trash"
              size="is-small"
              @click="deleteDeclaration(props.row.declarationId)"
            />
          </template>
        </b-table-column>

        <template #detail="props">
          <tr v-for="(e, index) in props.row.relaunches" :key="index">
            <td><strong>{{ `${index+1} reminder:` }}</strong></td>
            <td> {{ $dayjs(e.sendAt).format('YYYY-MM-DD') }}</td>
          </tr>
        </template>
      </b-table>
    </section>
  </div>
</template>

<script>
import Distribution from '../../services/v2/distribution'
import { saveAs } from 'file-saver'

export default {
  props: {
    distributor: {
      default: () => {},
      type: Object
    }
  },
  data () {
    return {
      isLoading: false,
      histories: []
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData () {
      this.isLoading = true
      const result = await Distribution.getHistory(this.distributor.id)
      this.histories = result
      this.isLoading = false
    },

    async downloadFile (declarationId) {
      try {
        const history = await Distribution.getDeclarations({ declarationId: declarationId })
        const result = await Distribution.getDeclarationFile(history[0].distributorCode, history[0].fileName)
        saveAs(result.data, `Declaration_${history[0].distributorCode}_${history[0].fileName}`)
      } catch (e) {
        this.$buefy.toast.open({ message: e.message || e, type: 'is-danger', duration: 4000 })
      }
    },

    async deleteDeclaration (declarationId) {
      try {
        await Distribution.deleteDeclaration(declarationId)
        this.$buefy.toast.open({ message: 'Declaration deleted successfully', type: 'is-primary', duration: 4000 })
        this.loadData()
      } catch (e) {
        this.$buefy.toast.open({ message: e.message || e, type: 'is-danger', duration: 4000 })
      }
    },

    async onOpenDetails (row) {
      if (!row.reminderId) return
      try {
        this.isLoading = true
        row.relaunches = await Distribution.getRelaunches(row.reminderId)
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        this.$buefy.toast.open({ message: e.message || e, type: 'is-danger', duration: 4000 })
      }
    }
  }

}
</script>

<style>
  tr.is-info {
        background: #45aaf2;
}

.delete-btn {
  opacity: 0;
  transition: opacity 0.2s ease;
  pointer-events: none;
}

tr:hover .delete-btn {
  opacity: 1;
  pointer-events: auto;
}
</style>
